"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.find = find;
// 递归循环找元素
function find(arr = [], id = '', callBack) {
  if (arr == null) return null;
  for (let obj of arr) {
    const _ref = obj.pane || {},
      simpleData = _ref.simpleData,
      iconsDesc = _ref.iconsDesc;
    if (obj.cid === id) {
      callBack(obj);
    } else {
      if (simpleData) {
        find(simpleData, id, callBack);
      }
      if (iconsDesc) {
        find(iconsDesc, id, callBack);
      }
      if (obj !== null && obj !== void 0 && obj.children) {
        find(obj.children, id, callBack);
      }
    }
  }
}